import { useState  } from 'react';
import { Box, Grid, TextField, Button, InputAdornment, IconButton } from "@mui/material"
import {
  Body,
} from "../../screens/Login/Login.styles"
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function ForgotPasswordVerify({email, password, errPwd, handleForgotPwEmailChange, resendForgtRequest, handleForgotPwdChange, isDisabled, timer, useForgotPwdSubmitMutation,useForgotPwdValidation}) {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleTogglePassword = () => setShowPassword((show) => !show);

    return(
        <Box sx={{width: '100%', margin: '0 auto', minHeight: `calc(100vh - 320px)`}}>        
          <Grid sx={{ marginBottom: '20px',}}>
              <TextField
                label={!email ? "Email address" : undefined}
                value={email}
                name="email"
                onChange={handleForgotPwEmailChange}
                fullWidth
                required
                disabled
                InputProps={{
                  sx: {
                    backgroundColor: 'white'
                  }
                }}
            />
          </Grid>
          <Body sx={{fontSize: '16px', fontWeight: 700, color: "#000", paddingBottom: '10px'}}>
            A password has been sent to your registered email address. Please enter it below to proceed.
          </Body>
          <Body sx={{fontSize: '12px', color: "#000", paddingBottom: '10px'}}>
            If you don't see the email within a few minutes, check your spam or junk folder.</Body>
          
          <Grid sx={{ marginBottom: '20px', }}>
              <TextField
                  type={showPassword ? "text" : "password"}
                  label={!password ? "Password" : undefined}
                value={password}
                name="password"
                onChange={handleForgotPwdChange}
                fullWidth
                required
                error={!!errPwd}
                helperText={errPwd}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        onClick={handleTogglePassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: {
                    backgroundColor: 'white'
                  }
                }}
            />
          </Grid>
          <Grid sx={{ marginBottom: '20px', width: '100%' }}>
          <Button
            type="submit"
            variant="contained"
            disabled={useForgotPwdValidation.isPending}
            sx={{width: '100%'}}
          >
            {useForgotPwdValidation.isPending? "Logging in..." : "Log in"}
          </Button>

          <Body sx={{fontSize: '12px', color: '#000'}}>Didn't get the password?
            <Button
              variant="text"
              onClick={resendForgtRequest}
              sx={{textTransform: 'capitalize', fontSize: '12px', pt: '4px'}}
              disabled={useForgotPwdSubmitMutation.isPending || isDisabled}>
              Resend 
            </Button>
            {isDisabled ? `in ${timer} seconds` : ''}
          </Body>
        </Grid>
      </Box>
    );
}